import { keepPreviousData, useQuery } from "@tanstack/react-query";
import * as Immutable from "immutable";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  widget: null,
  cachedValues: null
};
const url = qualifyUrl("plugins/org.graylog.plugins.widgetexport/widgetexport");
export const fetchWidgetData = (exportCallId) => fetch("GET", `${url}/${exportCallId}`).then(
  ({ created_at, widget, data }) => ({
    widget,
    cachedValues: data && {
      type: data.type,
      calculatedAt: created_at,
      result: [data.results],
      types: Immutable.List(),
      hasError: void 0,
      errorMessage: void 0
    }
  })
);
const useWidgetData = (exportCallId) => {
  const { data, refetch, isFetching } = useQuery({
    queryKey: ["exported-widget-date", exportCallId],
    queryFn: () => defaultOnError(
      fetchWidgetData(exportCallId),
      i18n.t("notifications.fetch_widget_data_failed", { ns: "enterprise_search" }),
      i18n.t("notifications.fetch_widget_data_failed_title", { ns: "enterprise_search" })
    ),
    placeholderData: keepPreviousData,
    enabled: !!exportCallId
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isFetching
  };
};
export default useWidgetData;
